export default __webpack_public_path__ + "static/media/background_desktop.a688922d.webp";